import { useMemo } from 'react';

import { appRouter } from '@route/app.router';

import { useStoreSelector } from '@hook/store/store.hooks';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { findNestedArray } from '@util/data/find-nested-array';

export const useRouteConfig = (): RouteConfigInterface => {
  const name = useStoreSelector((state) => state.route.name);

  return useMemo(
    () =>
      findNestedArray(appRouter.routes as RouteConfigInterface[], (route) => route.name === name) ??
      ({} as RouteConfigInterface),
    [name],
  );
};
